"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _customer = require("redux/modules/customer");

var _address = require("redux/modules/address");

var _components = require("components");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressSettingsPopup = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(AddressSettingsPopup, _React$Component);

  function AddressSettingsPopup(props) {
    (0, _classCallCheck3.default)(this, AddressSettingsPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AddressSettingsPopup.__proto__ || (0, _getPrototypeOf2.default)(AddressSettingsPopup)).call(this, props));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.state = {
      message: null
    };
    return _this;
  }

  (0, _createClass3.default)(AddressSettingsPopup, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.getCustomer();
      var _props$customer$custo = this.props.customer.customer,
          countryCode = _props$customer$custo.countryCode,
          postalCode = _props$customer$custo.postalCode;

      if (countryCode === "US" || countryCode === "CA") {
        this.props.validatePostalCode({ countryCode: countryCode, postalCode: postalCode });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var countryCode = this.props.customer.customer.countryCode;

      if (countryCode === "US" || countryCode === "CA") {
        this.props.resetPostalCode();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextProps.address !== this.props.address) {
        return true;
      }
      if (nextProps.updatingAddress !== this.props.updatingAddress) {
        return true;
      }
      if (nextState.message !== this.state.message) {
        return true;
      }
      if (nextProps.customer.updateError !== this.props.customer.updateError) {
        return true;
      }
      return false;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.customer.customer.postalCode !== this.props.customer.customer.postalCode) {
        var _nextProps$customer$c = nextProps.customer.customer,
            countryCode = _nextProps$customer$c.countryCode,
            postalCode = _nextProps$customer$c.postalCode;

        if (countryCode === "US" || countryCode === "CA") {
          this.props.validatePostalCode({ countryCode: countryCode, postalCode: postalCode });
        }
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(values) {
      var _this2 = this;

      this.setState({
        message: null
      });

      var vat = this.props.vat[values.vatNo];
      if (vat) {
        if (vat["vatNo"]) {
          values.vatNo = vat.vatNo.replace(" ", "");
          values.vatSignature = vat.signature;
        }
      }

      return this.props.updateCustomerAddress(_ramda2.default.pickBy(_ramda2.default.complement(_ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil)), values)).then(function () {
        return _this2.setState({
          message: "Successfully updated billing address"
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props$customer = this.props.customer,
          customer = _props$customer.customer,
          updating = _props$customer.updatingAddress,
          error = _props$customer.updateError;


      var initialValues = customer ? customer.state ? {
        name: customer.name,
        company: customer.company,
        address: customer.address1,
        postalCode: customer.postalCode,
        city: customer.city,
        country: customer.countryCode,
        vatNo: customer.vatNo,
        state: customer.state,
        address2: customer.address2
      } : {
        name: customer.name,
        company: customer.company,
        address: customer.address1,
        postalCode: customer.postalCode,
        city: customer.city,
        country: customer.countryCode,
        vatNo: customer.vatNo,
        address2: customer.address2
      } : { country: "US" };

      return _react2.default.createElement(_components.AddressSettingsForm, {
        initialValues: initialValues,
        paypalContainerId: "paypal-container",
        updating: updating,
        errorMsg: error,
        message: this.state.message,
        onSubmit: this.handleSubmit,
        validatePostalCode: this.props.validatePostalCode,
        address: this.props.address
      });
    }
  }]);
  return AddressSettingsPopup;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    customer: state.customer,
    userEmail: state.user.email,
    address: state.address,
    vat: state.vat
  };
}, {
  getCustomer: _customer.getCustomer,
  updateCustomerAddress: _customer.updateCustomerAddress,
  validatePostalCode: _address.validatePostalCode,
  resetPostalCode: _address.resetPostalCode
})(AddressSettingsPopup);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AddressSettingsPopup/AddressSettingsPopup.jsx
// module id = 2555
// module chunks = 0